import { Component, OnInit, input, inject } from '@angular/core';
import { I18NextAdapterPipe, I18nService } from '@pflegix/i18n';
import { Language } from '@pflegix/types';
import { MultiSelectComponent, MultiSelectOption } from '../multi-select/multi-select.component';
import { LANGUAGE_MULTI_SELECT_NAMESPACE } from './i18n/const/language-dropdown-namespace.const';
import { LANGUAGE_MULTI_SELECT_TRANSLATION_DE } from './i18n/de/language-multi-select.translation.de';
import { LANGUAGE_MULTI_SELECT_TRANSLATION_EN } from './i18n/en/language-multi-select.translation.en';

@Component({
  selector: 'pfx-language-multi-select',
  imports: [MultiSelectComponent, I18NextAdapterPipe],
  templateUrl: './language-multi-select.component.html',
  styleUrl: './language-multi-select.component.scss',
})
export class LanguageMultiSelectComponent extends MultiSelectComponent implements OnInit {
  private readonly i18n = inject(I18nService);

  public override i18nNamespace = input<string | undefined>(LANGUAGE_MULTI_SELECT_NAMESPACE);

  protected languageOptions: MultiSelectOption[] = [];

  public ngOnInit(): void {
    this.i18n.addTranslations({
      namespace: LANGUAGE_MULTI_SELECT_NAMESPACE,
      de: LANGUAGE_MULTI_SELECT_TRANSLATION_DE,
      en: LANGUAGE_MULTI_SELECT_TRANSLATION_EN,
    });

    this.languageOptions = Object.values(Language).map((language) => ({
      label: this.i18n.t(language.toLowerCase(), { ns: LANGUAGE_MULTI_SELECT_NAMESPACE }),
      value: language,
    }));
  }
}
